module.exports = __webpack_public_path__ + "static/media/HP-Icon1-@2x.dcfb22a5.png";